import { primaryColourMain } from 'app/agriculture/material';

const height = 60;
const width = 50;
const ellipseRadius = 5;
const horizontalCenter = width / 2;

export function DynamicTankIcon({ level }: { level: number | null }) {
    return (
        <svg
            key={level}
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/*Grey background*/}
            <rect
                x="0"
                y={ellipseRadius}
                width={width}
                height={height - ellipseRadius * 2}
                fill="#EDEDED"
            />

            {/*Top of Tank*/}
            <ellipse
                cx={horizontalCenter}
                cy={ellipseRadius}
                rx={horizontalCenter}
                ry={ellipseRadius}
                fill="#E6E5E5"
            />

            {/*Base of Tank*/}
            <ellipse
                id="base-of-tank"
                cx={horizontalCenter}
                cy={height - ellipseRadius}
                rx={horizontalCenter}
                ry={ellipseRadius}
                fill="#EDEDED"
            />

            {!level ? null : <Fluid level={level} />}
        </svg>
    );
}

function Fluid({ level }: { level: number }) {
    // const animationDuration = 0.5;
    const levelHeight = level / 2;
    const levelOffset = height - levelHeight - 5;
    return (
        <>
            {/*Blue Tank fluid */}
            <rect
                id="tank-fluid"
                x="0"
                y={levelOffset}
                width={width}
                height={levelHeight}
                fill={primaryColourMain}
            >
                {/*<animate*/}
                {/*    attributeName="y"*/}
                {/*    from={height - ellipseRadius}*/}
                {/*    to={levelOffset}*/}
                {/*    dur={animationDuration}*/}
                {/*    begin="0s"*/}
                {/*    fill="freeze"*/}
                {/*/>*/}
                {/*<animate*/}
                {/*    attributeName="height"*/}
                {/*    from={0}*/}
                {/*    to={levelHeight}*/}
                {/*    dur={animationDuration}*/}
                {/*    begin="0s"*/}
                {/*    fill="freeze"*/}
                {/*/>*/}
            </rect>

            {/*Blue base of tank*/}
            <ellipse
                id="base-of-fluid"
                cx={horizontalCenter}
                cy={height - ellipseRadius}
                rx={horizontalCenter}
                ry={ellipseRadius}
                fill={primaryColourMain}
            />

            {/*Top of tank fluid*/}
            <ellipse
                id="top-of-fluid"
                cx={horizontalCenter}
                cy={levelOffset}
                rx={horizontalCenter}
                ry={ellipseRadius}
                fill="#1954D8"
            >
                {/*<animate*/}
                {/*    attributeName="cy"*/}
                {/*    from={height - ellipseRadius}*/}
                {/*    to={levelOffset}*/}
                {/*    dur={animationDuration}*/}
                {/*    begin="0s"*/}
                {/*    fill="freeze"*/}
                {/*/>*/}
            </ellipse>
        </>
    );
}
